export default __webpack_public_path__ + "static/media/all-orders.9ef96e9b.png";